<template>
  <div v-if="isTrialActive && trialRemainingDays <= 3"
       class="bg-amber-50 border-b border-amber-200 px-6 py-3">
    <div class="max-w-6xl mx-auto flex items-center justify-between gap-4 flex-wrap">
      <p class="text-sm text-amber-800">
        <span class="font-semibold">Período de prueba:</span>
        Te quedan {{ trialRemainingDays }} día{{ trialRemainingDays !== 1 ? 's' : '' }}.
        {{ trialRemainingDays === 0 ? 'Tu prueba vence hoy.' : '' }}
      </p>
      <router-link to="/billing"
        class="text-sm font-semibold text-amber-900 underline hover:no-underline whitespace-nowrap">
        Contratar plan ahora
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'TrialCountdownBanner',
  computed: {
    ...mapGetters({
      isTrialActive: 'billing/isTrialActive',
      trialRemainingDays: 'billing/trialRemainingDays',
    }),
  },
};
</script>
